module.exports = __webpack_public_path__ + "img/logochami.a9c57d35.png";